<script lang="ts" setup></script>

<template>
  <q-dialog :transition-duration="100">
    <div class="q-dialog__body">
      <i-app-close v-close-popup class="close-dialog-icon" />
      <slot />
    </div>

    <slot name="bottom" />
  </q-dialog>
</template>

<style lang="scss">
.q-dialog {
  @media (max-width: $breakpoint-xs) {
    &__inner {
      padding: 0;
    }
  }

  .title {
    padding: $space-60;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: -0.48px;

    @media (max-width: $breakpoint-xs) {
      padding: $space-lg $space-xxl;
      font-size: 18px;
      font-weight: 400;
      line-height: 28px;
      letter-spacing: -0.18px;
    }
  }

  &__backdrop {
    background: rgba($gray-01, 0.2);
    backdrop-filter: blur(8px);
  }

  &__body {
    position: relative;
    color: #fff;
    border-radius: 16px !important;
    background: $base-white;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;

    @media (max-width: $breakpoint-xs) {
      width: 100%;
      height: 100%;
      max-height: 100dvh !important;
      border-radius: 0 !important;
    }

    .close-dialog-icon {
      position: absolute;
      top: $space-lg;
      right: $space-lg;
      width: 48px;
      height: 48px;
      padding: $space-lg;
      z-index: 1;
      cursor: pointer;
      color: $zinc-300;

      @media (max-width: $breakpoint-xs) {
        top: 18px;
        right: 16px;
        width: 16px;
        height: 16px;
        padding: 0;
      }
    }
  }

  .q-card {
    background: transparent;
    padding: 40px 40px 32px;
    min-width: 300px;

    @media (max-width: $breakpoint-xs) {
      width: 100%;
      padding: 40px 20px 32px;
    }

    &__section {
      padding: 0;
    }
  }
}
</style>
